import ThemeOptions from './ThemeOptions';
import Watchlist from './Watchlist';
import Screener from './Screener';
import User from './User';
import Topic from './Topic';
import Sentiment from './Sentiment';
import Filings from './Filings';
import Comparison from './Comparison';
import HomePage from './HomePage';
import Alerts from './Alerts';
import WatchlistDialog from './WatchlistDialog';
import SocialSentiment from './SocialSentiment';
import AccessController from './AccessController';

export default {
  WatchlistDialog,
  ThemeOptions,
  Watchlist,
  Screener,
  User,
  Topic,
  Sentiment,
  Filings,
  Comparison,
  HomePage,
  Alerts,
  SocialSentiment,
  AccessController,
};
